// ThankYouPage.js
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import banner from "./assets/img/logo_transparent.png";

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || "https://systalk-dev.azure-api.net/wagtag";

function ThankYouPage() {
    const location = useLocation();
    const { latitude, longitude, responseBody, fromApp, isEmergencyAlert } = location.state || {};

    const [email, setEmail] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [submitButtonDisabled, setSetSubmitButtonDisabled] = useState(false);

    const handleSubscribe = async () => {
        if (!email) {
            alert("Please enter a valid email address.");
            return;
        }

        try {
            const response = await fetch(`${apiBaseUrl}/api/Notifications/Subscribe`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    EmailAddress: email,
                    Latitude: latitude,
                    Longitude: longitude,
                }),
            });

            if (response.ok) {
                setSuccessMessage("You have successfully subscribed to notifications.");
                setErrorMessage("");
                setEmail("");
                setSetSubmitButtonDisabled(true);
            } else {
                const errorData = await response.json();
                setErrorMessage(errorData.Message || "Failed to subscribe to notifications.");
            }
        } catch (error) {
            console.error("Error subscribing to notifications:", error);
            setErrorMessage("An error occurred. Please try again later.");
        }
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: "#d3d3d3" }}>
            <main style={styles.main}>
                <header style={styles.header}>
                    <div style={styles.headerImageContainer}>
                        <img src={banner} alt="WagTag" style={styles.imagePreview} />
                    </div>
                </header>

                <div style={styles.form}>
                    <div style={styles.formRow}>
                        <h1 style={styles.title}>Thank You!</h1>

                        {responseBody && (
                            <div style={styles.infoSection}>
                                <p style={styles.infoText}>{responseBody}</p>
                            </div>
                        )}

                        <p style={styles.message}>
                            {isEmergencyAlert
                                ? "Thank you. The pet owners friends have been notified."
                                : "Thank you for helping reunite lost pets with their families! Install our app to join the WagTag community."}
                        </p>

                        {!fromApp || fromApp === 0 ? null : (  
                            <div style={{ textAlign: 'center', margin: '20px 0' }}>
                                <button
                                onClick={() => {
                                    const schemeUrl = 'wagtag://home';
                                    window.location.href = schemeUrl;
                                }}
                                style={{
                                    background: '#4CAF50',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: 6,
                                    padding: '12px 28px',
                                    fontSize: 17,
                                    cursor: 'pointer',
                                    fontWeight: 'bold',
                                }}
                                >
                                Return to the WagTag App
                                </button>
                            </div>
                        )}

                        <div align="center" style={{ paddingTop: "10px" }}>
                            <a
                                href="https://play.google.com/store/apps/details?id=com.wagtag"
                                target="_blank"
                                rel="noreferrer"
                                style={{ marginRight: "10px" }}
                            >
                                <img
                                    src="https://wagtagprod.blob.core.windows.net/public/GooglePlayStore.png"
                                    alt="Get it on Google Play"
                                    width="150"
                                    style={{ verticalAlign: "middle" }}
                                />
                            </a>
                            <a
                                href="https://apps.apple.com/au/app/wagtag/id6738763040"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img
                                    src="https://wagtagprod.blob.core.windows.net/public/AppleAppStore.png"
                                    alt="Download on the App Store"
                                    width="150"
                                    style={{ verticalAlign: "middle" }}
                                />
                            </a>
                        </div>
                    </div>
                    <div style={styles.formRow}>
                        {successMessage && <p style={styles.successMessage}>{successMessage}</p>}
                        {errorMessage && <p style={styles.errorMessage}>{errorMessage}</p>}
                    </div>

                    <div style={styles.navigationContainer}>
                        <hr style={styles.hr} />
                        <footer style={styles.footer}>
                            <p>
                                Visit us at{" "}
                                <a href="https://www.wagtag.com.au" target="_blank" rel="noopener noreferrer">
                                    www.wagtag.com.au
                                </a>
                            </p>
                        </footer>
                    </div>
                </div>
            </main>
        </div>
    );
}

const styles = {
    main: {
        flex: 1,
        padding: "10px",
        maxWidth: "600px",
        margin: "0 auto",
        width: "95%",
        backgroundColor: "#d3d3d3",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    },
    header: {
        backgroundColor: "#4CAF50",
        color: "white",
        padding: "5px 5px",
        borderTopLeftRadius: "8px",
        borderTopRightRadius: "8px",
    },
    headerImageContainer: {
        width: "100%",
        maxWidth: "300px",
        margin: "0 auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
    },
    imagePreview: {
        width: "100%",
        maxHeight: "80px",
        height: "auto",
        objectFit: "contain",
        borderRadius: "8px",
    },
    form: {
        display: "flex",
        flexDirection: "column",
        gap: "5px",
        backgroundColor: "#ffffff",
        paddingLeft: 20,
        paddingRight: 20,
        borderBottomLeftRadius: "8px",
        borderBottomRightRadius: "8px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        minHeight: "40vh",
    },
    formRow: {
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        marginBottom: "8px",
        marginRight: "0",
    },
    navigationContainer: {
        display: "flex",
        flexDirection: "column",
        marginTop: "auto",
    },
    footer: {
        backgroundColor: "#ffffff",
        paddingTop: "10px",
        textAlign: "center",
    },
    hr: {
        border: "none",
        borderTop: "1px solid #ccc",
        margin: "16px 0",
        width: "100%",
    },
    title: {
        fontSize: "24px",
        fontWeight: "bold",
        color: "#4CAF50",
        marginBottom: "4px",
    },
    message: {
        fontSize: "18px",
        margin: "10px 0",
    },
    infoText: {
        fontSize: "18px",
        margin: "10px 0",
    },
    subscriptionContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "8px",
        flexWrap: "wrap",
    },
    textInput: {
        width: "100%",
        padding: "10px",
        fontSize: "16px",
        border: "1px solid #ccc",
        borderRadius: "4px",
        flex: "1 1 260px",
    },
    submitButton: {
        padding: "12px 20px",
        minWidth: "120px",
        backgroundColor: "#4CAF50",
        color: "white",
        fontSize: "16px",
        fontWeight: "bold",
        border: "none",
        borderRadius: "4px",
        cursor: "pointer",
        alignSelf: "flex-start",
    },
    successMessage: {
        color: "green",
        marginTop: "6px",
    },
    errorMessage: {
        color: "red",
        marginTop: "6px",
    },
};

export default ThankYouPage;